var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Container, ContainerDisplays, ContainerFlexGaps } from '../../../../templates/container';
import { StockStatuses } from './types';
import { Text, TextVariants } from '../../../../atoms/text';
import { Icon, IconSizes } from '../../../../atoms/icon';
import { IconStates } from '../../../../atoms/icon/types';
var SI = function (_a) {
    var props = __rest(_a, []);
    var stockLabel = props.stockLabel, stockStatus = props.stockStatus;
    var containerConfig = {
        display: ContainerDisplays.Flex,
        flexGap: ContainerFlexGaps.Size_2
    };
    var labelConfig = {
        isHtml: true,
        content: stockLabel,
        variant: TextVariants.Body2
    };
    var iconName = '';
    var iconState;
    switch (stockStatus) {
        case StockStatuses.InStock:
            iconName = 'pmi-icon-check-full';
            iconState = IconStates.Success;
            break;
        case StockStatuses.OutOfStock:
            iconName = 'pmi-icon-exclamation';
            iconState = IconStates.Error;
            break;
        case StockStatuses.LowStock:
            iconName = 'pmi-icon-exclamation';
            iconState = IconStates.Warning;
            break;
        default:
            break;
    }
    var iconConfig = {
        image: iconName,
        size: IconSizes.Small,
        state: iconState
    };
    return (React.createElement(Container, __assign({}, containerConfig),
        iconName && iconState && React.createElement(Icon, __assign({}, iconConfig)),
        stockLabel && React.createElement(Text, __assign({}, labelConfig))));
};
export { SI as StockInfo };
